export function isDevelopment(environment) {
    return !environment || environment === 'development';
}
export function isProduction(environment) {
    return environment === 'production';
}

//# sourceMappingURL=environment.js.map